export default __webpack_public_path__ + "static/media/htb-ramiro.b3cdea16.jpg";